module.exports = __webpack_public_path__ + "img/home-top@2x.968a2258.png";